module.exports = __webpack_public_path__ + "img/1f104d4.png";